import { useState } from 'react';
import { useToast } from '@crisellevaldez/speculo-ui';
import { useOrganizationStore } from '../../../stores/useOrganizationStore';
import { createCloudRunAxios } from '../../../api/axios';

const remiApi = createCloudRunAxios('remi-api');

export const useCallAnalysis = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const { showToast } = useToast();
  const { organization } = useOrganizationStore();

  /**
   * Update the call outcome via Remi REST API
   * PUT /api/v1/calls/{call_id}/outcome
   * @param callId The ID of the call to update
   * @param outcome The new outcome value
   * @param notes Optional notes
   * @returns A promise that resolves to true if the update was successful
   */
  const updateCallAnalysis = async (callId: string, outcome: string, notes?: string) => {
    if (!organization?.id) {
      showToast({
        message: 'Organization ID is required to update call analysis',
        variant: 'error',
      });
      return false;
    }

    try {
      setIsUpdating(true);
      await remiApi.patch(`/api/v1/calls/${callId}/outcome`, {
        outcome,
        notes: notes || undefined,
      }, {
        params: { organization_id: organization.id },
      });

      showToast({
        message: 'Call outcome has been successfully updated',
        variant: 'success',
      });

      return true;
    } catch (error) {
      console.error('Error updating call outcome:', error);
      showToast({
        message: 'An error occurred while updating the call outcome',
        variant: 'error',
      });
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    updateCallAnalysis,
    isUpdating,
  };
};
